import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=d4c70f86&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=ts&"
export * from "./AppMain.vue?vue&type=script&lang=ts&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=d4c70f86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c70f86",
  null
  
)

export default component.exports